import React, { useRef } from 'react'
import bgimg from '../../assets/image/bgimg.avif'
import bgimg2 from '../../assets/image/bgimg2.avif';
import { Skill } from './Skill';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { ScrollTrigger } from 'gsap/ScrollTrigger'; // Import ScrollTrigger

gsap.registerPlugin(ScrollTrigger);

export const About = () => {
    // 1. Refs for the elements we want to animate
    const aboutSectionRef = useRef(null);
    const bigDRef = useRef(null);         // The giant 'D'
    const greetingRef = useRef(null);     // "Hey there, I'm"
    const nameRef = useRef(null);         // "Darshik!"
    const subtitleRef = useRef(null);     // "Welcome..."
    const infoBoxRef = useRef(null);      // The bordered info box

    useGSAP(() => {
        // Create a timeline for the About section
        const aboutTl = gsap.timeline({
            scrollTrigger: {
                trigger: aboutSectionRef.current, // Trigger animation when this element enters view
                start: "top 80%",                 // Start when the top of the element is 80% down the viewport
                toggleActions: "play none none reverse", // Play once and don't reverse
                // markers: true, // Uncomment for debugging
            },
            defaults: { ease: "power3.out" },
            delay: .5, // Slight delay before starting the animation
            // delay: 1.8, // Slight delay before starting the animation
        });

        // --- Animation Sequence ---

        // 1. Animate the Big "D" on the right
        aboutTl.from(bigDRef.current, {
            scale: 0.5,
            opacity: 0,
            filter: 'blur(8px)',
            duration: 1.5,
        }, 0) // Start at the beginning of the timeline

            // 2. Animate "Hey there, I'm"
            .from(greetingRef.current, {
                x: -50,
                opacity: 0,
                filter: 'blur(4px)',
                duration: 1,
            }, "<0.3") // Starts 0.3s after the Big D animation began

            // 3. Animate "Darshik!" with a different direction for emphasis
            .from(nameRef.current, {
                y: 30,
                opacity: 0,
                filter: 'blur(4px)',
                duration: 1,
            }, "<0.2") // Starts 0.2s after the greeting animation began

            // 4. Animate the subtitle
            .from(subtitleRef.current, {
                x: -30,
                opacity: 0,
                filter: 'blur(4px)',
                duration: 0.8,
            }, "<0.3") // Starts 0.3s after the name animation began

            // 5. Animate the bordered info box
            .from(infoBoxRef.current, {
                scale: 0.9,
                opacity: 0,
                filter: 'blur(4px)',
                duration: 1,
            }, ">-0.5"); // Starts 0.5s *before* the previous animation ends (smooth overlap)

    }, { scope: aboutSectionRef });

    return (
        <>
            <div id='about' ref={aboutSectionRef}>
                <section className="md:px-20 xl:px-32 text-center text-surface lg:text-left py-14 md:py-24">
                    <div className='container mx-auto lg:flex justify-between items-center'>
                        <div ref={bigDRef} className='lg:order-2 text-center hidden lg:block'>
                            <h2 className='font-andika text-7xl md:text-9xl lg:text-[500px] font-extrabold leading-none bg-gradient-to-b from-[#E7F53C] to-[#383835] inline-block text-transparent bg-clip-text'>D<span className='lg:hidden'>arshik</span></h2>
                        </div>
                        <div className=''>
                            <p ref={greetingRef} className='font-andika dark:text-tx-col text-3xl md:text-5xl lg:text-7xl font-semibold'>
                                Hey there, I'm
                                <span ref={nameRef} className='block font-pockota text-y-col !leading-relaxed font-bold'>Darshik!</span>
                            </p>
                            <p ref={subtitleRef} className='text-slate-600 dark:text-slate-400 md:text-xl lg:text-2xl font-light'>Welcome to my corner of the internet.</p>
                            <div ref={infoBoxRef} className="max-w-[300px] sm:max-w-[550px] rounded-2xl sm:rounded-3xl mx-auto bg-gradient-to-r from-[#E7F53C54] to-[#ffffff40] p-[3px] mt-5 relative">
                                <div className="p-2 sm:p-5 md:py-8 md:px-10 rounded-[13px] sm:rounded-[21px] bg-transparent dark:text-white relative overflow-hidden">
                                    <img className='absolute -top-[100px] left-0 blur-[2px] scale-[5] hidden dark:block pointer-events-none' src={bgimg} alt="Dark Mode Icon" />
                                    <img className='absolute -top-[100px] left-0 blur-[2px] scale-[5] block dark:hidden pointer-events-none' src={bgimg2} alt="Light Mode Icon" />
                                    <p className='md:text-xl font-light relative !leading-relaxed'>
                                        I'm a<span className='text-y-col font-medium font-pockota'> front-end </span>developer who
                                        <span className='sm:block'>constantly seeks out innovative solutions</span>
                                        to everyday problems</p>
                                    {/* <h1 className='text-xl'>I’m a front-end developer who <br/> constantly seeks out innovative solutions <br/> to everyday problems</h1> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Skill />
            </div>
        </>
    )
}
